import React, { useState } from 'react';
import Button from 'components/ui/Button';
import { useTranslation } from 'react-i18next';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { validate } from 'store/auth';
import { updateLoading } from 'store/app';
import CodeInput from 'components/ui/CodeInput';

const Validate = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();

  const [code, setCode] = useState('');

  const handleSubmit = () => {
    dispatch(validate({ card: location.state.card, code: code }))
      .then((res) => {
        if (res.payload.Result === 1) {
          navigate('/home')
        }
        dispatch(updateLoading(false))
      })
      .catch(() => {
        dispatch(updateLoading(false))
      })
  };

  return (
    <div className="h-full w-full flex flex-col justify-center items-center bg-[#fafafa] relative px-10">
      <div className="w-full h-fit flex flex-col gap-8 -mt-20">
        <div className="h-[30%] flex justify-center items-center mb-5">
          <img src="/library-logo.svg" alt='sheraton' />
        </div>
        <div className="w-3/4">
          <span className="font-bold text-4xl">
            {t('auth.login_title')}
          </span>
        </div>
        <span className="text-xs text-[#808080] font-semibold">
          {t('auth.login_text')}
        </span>
        <div className="flex flex-col gap-2">
          <span className="text-[#6E6260] font-semibold">
            {t('auth.insert_sms_code')}
          </span>
          <CodeInput
            length={6}
            defaultValue={code}
            onChange={(otp) => setCode(otp)}
          />
        </div>
        <Button
          onClick={handleSubmit}
          text={t('general.next')}
          isDisabled={code.length < 6}
        />
      </div>
      <div className="absolute bottom-10 w-full px-10 flex justify-between items-center">
        <span className="text-xs text-[#808080] font-semibold">
          {t('language.change')}
        </span>
        <span className="text-xs text-[#808080] font-semibold uppercase">
          {t('language.pt')}
        </span>
      </div>
    </div>
  )
}

export default Validate;